import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput, MDBView, MDBDataTable} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card ,Empty   } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined, RightCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { api, URL } from '../../api';
import Modeladdshortterm from './Modeladdshortterm';
import Modeladdshortmodule from './Modeladdshortmodule';
import Showmodulelist from './Showmodulelist';




export default class Curriculumshortterm extends Component {

    constructor(props) {
        super(props);
        this.state = {

          modal: false,
          type:'1',
          Course:[],
          Course2:[],
          year:'2560',
          Curriculumopen:[],

          pagination: {
            current: 1,
            pageSize: 20,
          },


          Course_ID:'',
          Course_Name_TH:'',
          Course_Name_En:'',
          Course_Credit:'',
          Course_Year:'',
          Course_T_Hour:'',
          Course_P_Hour:'',
          Course_Detail_TH:'',
          Course_Detail_EN:'',
          Faculty_ID:'',

          UserUPDATE:'',
          datsShortcourse:[],
          sum:'',



        };
       
        this.onChange = this.onChange.bind(this);
        this.getCurriculumopen = this.getCurriculumopen.bind(this);
        this.getShortcourse = this.getShortcourse.bind(this);
        this.getShortcourseforuser = this.getShortcourseforuser.bind(this);
         this.onChangeyear = this.onChangeyear.bind(this);

      }


         componentDidMount(){

           if (localStorage.getItem('name') == null) {
                 window.location.href = 'https://e-student.kpru.ac.th/creditbank'
           } else {
       
           }
                   Axios.get(`https://mua.kpru.ac.th/frontend/creditbank/showcourse/2559`,
                 //  Axios.get(`https://git.kpru.ac.th/frontend_tqf/creditbank/showcourse/2559`,
                 //  Axios.get(`https://e-student.kpru.ac.th/e-tqf/Administrator_Course/showlist`,
                     //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                     {headers: {
                       // Authorization: 'Bearer ' + localStorage.getItem('myData')
                     }
                     })
                     //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                     .then(res => {
                        // console.log(res.data[0].id)
                      //  console.log(res.data[0].Course_Detail_TH)
                        const Course = res.data.filter( ({ Curriculum_Year }) => Curriculum_Year >= this.state.year );
                      //  console.log(Course)
                       //  const Course = res.data;
                         this.setState({ Course2 : Course });
                     })   
                     
                     this.setState({ UserUPDATE:localStorage.getItem('Citizen_ID')})   
                   this.getShortcourseforuser()
            }



            getShortcourse() {
                  api.get('index/getShortcourse/'+this.state.UserUPDATE+'/'+this.state.Course_ID,
                  {headers: {
                      // Authorization: 'Bearer ' + localStorage.getItem('myData')
                  }
                  })
                  .then(res => {
                          console.log(res.data)
                      //   console.log(res.data[0].Studentcb_NAME)
                      //   console.log(ppp)
                      //   const student = res.data.filter( ({ citizen_id }) => citizen_id.substring(0, 7) === this.state.major );
                         const datsShortcourse = res.data;
                       this.setState({ datsShortcourse });
                          // this.setState({   Shortcourse_Nameshortterm_TH:res.data[0].Shortcourse_Nameshortterm_TH,
                          //                 lname:res.data[0].Studentcb_LASTNAME,
                          //                 datedb:res.data[0].Studentcb_DB,
                          //                 Citizen_ID:res.data[0].Studentcb_Citizen_ID
                          //  });
                  })
            }

            getShortcourseforuser() {
              api.get('index/getShortcourseforuser/'+localStorage.getItem('Citizen_ID'),
              {headers: {
                  // Authorization: 'Bearer ' + localStorage.getItem('myData')
              }
              })
              .then(res => {
                      console.log(res.data)
                  //   console.log(res.data[0].Studentcb_NAME)
                  //   console.log(ppp)
                  //   const student = res.data.filter( ({ citizen_id }) => citizen_id.substring(0, 7) === this.state.major );
                     const datsShortcourse = res.data;
                   this.setState({ datsShortcourse });
                      // this.setState({   Shortcourse_Nameshortterm_TH:res.data[0].Shortcourse_Nameshortterm_TH,
                      //                 lname:res.data[0].Studentcb_LASTNAME,
                      //                 datedb:res.data[0].Studentcb_DB,
                      //                 Citizen_ID:res.data[0].Studentcb_Citizen_ID
                      //  });
              })
            }



         onChange(value) {
            const Courseselect = this.state.Course.filter( ({ Course_ID }) => Course_ID.substring(0, 7) === value.substring(0, 7) );
            //  const idemp = value;
            //  console.log(Courseselect[0].Course_ID);
            this.setState({ Course_ID : Courseselect[0].Course_ID.substring(0, 7) });
            this.setState({ Course_Name_TH : Courseselect[0].Course_Name_TH });
            this.setState({ Course_Name_En : Courseselect[0].Course_Name_En });
            this.setState({ Course_Credit : Courseselect[0].Course_Credit });
            this.setState({ Course_Year : Courseselect[0].Curriculum_Year });
            this.setState({ Course_T_Hour : Courseselect[0].Course_T_Hour });
            this.setState({ Course_P_Hour : Courseselect[0].Course_P_Hour });
            this.setState({ Course_Detail_TH : Courseselect[0].Course_Detail_TH });
            this.setState({ Course_Detail_EN : Courseselect[0].Course_Detail_EN });
            this.setState({ Faculty_ID : Courseselect[0].Faculty_ID });

const ss = Number(Courseselect[0].Course_T_Hour);
const ss2 = Number(Courseselect[0].Course_P_Hour);
const ss3 = (ss+ss2)*15;

            this.setState({ sum : ss3});
 
            this.getCurriculumopen()
         setTimeout(() => {
        //   this.getShortcourse()
         }, 1000);
           
  
         }

         onChangeyear(value) {

            const Courseselect = this.state.Course2.filter( ({ Curriculum_Year }) => Curriculum_Year === value );

            this.setState({ Course : Courseselect });
            //  const idemp = value;
            //  console.log(Courseselect[0].Course_ID);


            // this.setState({ Course_ID : Courseselect[0].Course_ID.substring(0, 7) });
            // this.setState({ Course_Name_TH : Courseselect[0].Course_Name_TH });
            // this.setState({ Course_Name_En : Courseselect[0].Course_Name_En });
            // this.setState({ Course_Credit : Courseselect[0].Course_Credit });
            // this.setState({ Course_Year : Courseselect[0].Curriculum_Year });
            // this.setState({ Course_T_Hour : Courseselect[0].Course_T_Hour });
            // this.setState({ Course_Detail_TH : Courseselect[0].Course_Detail_TH });
            // this.setState({ Course_Detail_EN : Courseselect[0].Course_Detail_EN });
            // this.setState({ Faculty_ID : Courseselect[0].Faculty_ID });
 
           // this.getCurriculumopen()
         setTimeout(() => {
        //   this.getShortcourse()
         }, 1000);
           
  
         }


          //ดึงหลักสูตรที่เปิดสอน
         getCurriculumopen() {
            setTimeout(() => {
               //ภายใน
               api.get('index/getCurriculumopen/'+this.state.Course_ID)
               .then(res => {
               //  console.log(res);
               //  this.setState({ bankname: res.data, loading: false })
                 this.setState({ Curriculumopen: res.data})
               }) 
             }, 0);
         }


  render() {
    console.log(this.state.Course)


    const suma = this.state.datsShortcourse.reduce(function (prev, current) {
      return prev + +current.Shortcourse_Credit
  }, 0);



    return (
      <div>
         <MDBContainer fluid>
         <Card type="inner" style={{ marginTop: 0 }} headStyle={{ backgroundColor: '#d0e5f8ff', color: '#ffffff' }}  title={<h4><MDBIcon icon="list-alt" /> จัดการหลักสูตรระยะสั้น/เพิ่มหลักสูตรระยะสั้น</h4> } extra={<a href="#"><p>คุณ{localStorage.getItem('name')}</p></a>} >

         <MDBRow>
            <MDBCol sm="3">
            <label htmlFor="example2"><MDBIcon icon="search" />  ปีของรายวิชาหลัก </label><br/>
            {this.state.Course2.length !==0 ?<>
            <Select
                    showSearch
                    style={{ width: 400 }}
                    placeholder="เลือกปีของรายวิชา"
                    optionFilterProp="children"
                    onChange={this.onChangeyear}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                   // onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    {/* <Option value="jack">Jack</Option>
                    <Option value="lucy">Lucy</Option>
                    <Option value="tom">Tom</Option> */}
                   
                   {/* {this.state.Course.map((Course,index )  => 
                   <option value={Course.Course_ID}>{Course.Course_ID + Course.Course_Name_TH + ' (ปี '+Course.Curriculum_Year+')'}</option>
                   )} */}
                   <option value='2569'>ปี 2569</option>
                   <option value='2568'>ปี 2568</option>
                   <option value='2567'>ปี 2567</option>
                   <option value='2566'>ปี 2566</option>
                  </Select>
            </>:<>
            ...กำลังโหลดข้อมูล...
            </>}
                
            </MDBCol>

            <MDBCol sm="4">
                 <label htmlFor="example2"><MDBIcon icon="search" />  ค้นหารหัสรายวิชาหลัก </label><br/>
                <Select
                    showSearch
                    style={{ width: 500 }}
                    placeholder="เลือกรหัสวิชา"
                    optionFilterProp="children"
                    onChange={this.onChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                   // onSearch={this.onSearch}

                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    {/* <Option value="jack">Jack</Option>
                    <Option value="lucy">Lucy</Option>
                    <Option value="tom">Tom</Option> */}
                   
                   {this.state.Course.map((Course,index )  => 
                   <option key={index} value={Course.Course_ID}>{Course.Course_ID + Course.Course_Name_TH + ' (ปี '+Course.Curriculum_Year+')'}</option>
                   )}
                  </Select>
            </MDBCol> 
       </MDBRow>

       <br/>
        <MDBRow>
                    <MDBCol sm="12">
                    
                            {this.state.Course_ID != '' ? <>
                            <MDBContainer >
                            <h2 className="display-5 deep-purple-text text-center">รายวิชา {this.state.Course_Name_TH}</h2>
                                <h4 className="display-5 deep-purple-text">รายละเอียดวิชา</h4>
                                {/* <p className="lead">This is a modified jumbotron that occupies the entire horizontal space of its parent.</p> */}
                                <MDBTable bordered responsiveMd>
                                <MDBTableHead color="stylish-color-dark" textWhite>
                                <tr>
                                    <th className="font-weight-bold">รหัสวิชา</th>
                                    <th className="font-weight-bold">ชื่อวิชาภาษาไทย</th>
                                    <th className="font-weight-bold">ชื่อวิชาภาษาอังกฤษ</th>
                                    <th className="font-weight-bold">หน่วยกิต</th>
                                    <th className="font-weight-bold">ปี</th>
                                    <th className="font-weight-bold">จำนวนชั่วโมง</th>
                                    <th className="font-weight-bold">คำอธิบายรายวิชาภาษาไทย</th>
                                    <th className="font-weight-bold">คำอธิบายรายวิชาภาษาอังกฤษ</th>
                                </tr>
                                </MDBTableHead>
                                <MDBTableBody>
                                    <tr>
                                    <td>{this.state.Course_ID}</td>
                                    <td>{this.state.Course_Name_TH}</td>
                                    <td>{this.state.Course_Name_En}</td>
                                    <td>{this.state.Course_Credit}</td>
                                    <td>{this.state.Course_Year}</td>
                                    <td>{this.state.sum}</td>
                                    <td>{this.state.Course_Detail_TH}</td>
                                    <td>{this.state.Course_Detail_EN}</td>
                                    </tr>
                                </MDBTableBody>
                                </MDBTable>
                                <br/>
                             
                                </MDBContainer>
                                 <Modeladdshortterm Course_ID={this.state.Course_ID} Course_YEAR={this.state.Course_Year} Faculty_ID={this.state.Faculty_ID} Credit={this.state.Course_Credit}  Course_Name_TH={this.state.Course_Name_TH} Course_Name_En={this.state.Course_Name_En} Course_Credit={this.state.Course_Credit} getShortcourseforuser={this.getShortcourseforuser} sumch={this.state.sum}/>
                                 <br/>
                            </>:<></>}

                                <MDBContainer fluid>
                                  
                                   <h4 className="display-5">รายการหลักสูตรระยะสั้น ภายใต้วิชา  {this.state.Course_Name_TH}</h4>
                             
                             

                            <MDBTable bordered responsiveMd >
                                <MDBTableHead  color="stylish-color-dark" textWhite>
                                    <tr>
                                    <th>#</th>
                                    <th className="font-weight-bold">ชื่อวิชา</th>
                                    <th className="font-weight-bold">จำนวนหน่วยกิต</th>
                                    <th className="font-weight-bold">เทอม</th>
                                    <th className="font-weight-bold">จำนวนชั่วโมง</th>
                                    <th className="font-weight-bold">หลักสูตรระยะสั้น</th>
                                   
                                    </tr>
                                </MDBTableHead>

                                <MDBTableBody>
                                {this.state.datsShortcourse.map((datsShortcourse,index) => {
                                  return  <tr>
                                    <td>{index+1}</td>
                                    <td>{datsShortcourse.Shortcourse_Nameshortterm_TH }<br/>({datsShortcourse.Shortcourse_Nameshortterm_EN })</td>
                                   
                                    <td>{datsShortcourse.Shortcourse_Credit }</td>
                                    <td>{datsShortcourse.Shortcourse_Team }</td>
                                    <td>{datsShortcourse.Shortcourse_Numch }</td>
                                    <td width="50%"> <Modeladdshortmodule Course_ID={datsShortcourse.Shortcourse_Course_ID} Shortcourse_Team={datsShortcourse.Shortcourse_Team} Shortcourse_Nameshortterm_TH={datsShortcourse.Shortcourse_Nameshortterm_TH} Shortcourse_ID={datsShortcourse.Shortcourse_ID} Course_YEAR={this.state.Course_Year} Faculty_ID={this.state.Faculty_ID} Credit={this.state.Course_Credit}  Course_Name_TH={this.state.Course_Name_TH} Course_Name_En={this.state.Course_Name_En} Course_Credit={this.state.Course_Credit} Shortcourse_Course_YEAR={datsShortcourse.Shortcourse_Course_YEAR}	/>
                                    {/* <br/>
                                    <Showmodulelist Course_ID={this.state.Course_ID}  /> */}
                                    </td>
                                    
                                   
                                    </tr>
                                   })}  
                                </MDBTableBody>
                           </MDBTable>

{/* <h4>หน่วยกิตรวม {suma} / {this.state.Course_Credit}</h4> */}

                            </MDBContainer>
                           
                     
                    </MDBCol>
        </MDBRow>




          <MDBRow>
                  <MDBContainer>
                    
                  </MDBContainer>
           </MDBRow>





         </Card>
         </MDBContainer>
      </div>
    )
  }
}
